export default __webpack_public_path__ + "static/media/grade.d361762d.png";